export * from './isMobile';
export { default } from './isMobile';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ismobilejs/esm/index.js
// module id = 560
// module chunks = 1